import React, { useEffect, useState, useContext, useMemo } from 'react';
import { Navigate } from 'react-router';
import OrderService from '../../../services/OrderService';
import OrderList from '../../layout/OrderList/OrderList';
import { UserContext } from '../../context/UserContext';
import { useSocket } from '../../context/SocketContext';
import Swal from 'sweetalert2';
import Notification from '../../components/Notification/Notification';
import './style.scss';
import { Button } from '@mui/material';
import OrderGroupingService from '../../../services/OrderGroupingService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';


const FollowUp = (props) => {
  const [orders, setOrders] = useState([]);
  const [groupOrders, setGroupOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notificationData, setNotificationData] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [isChangePage, setIsChangePage] = useState(false);
  const { selectedStore, user } = useContext(UserContext);
  const socket = useSocket();
  const storeOptions = [];

  const orderService = useMemo(() => new OrderService(), []);
  const orderGroupingService = useMemo(() => new OrderGroupingService(), []);

  const [actualList, setActualList] = useState("PENDING");
  const [pendingOrders, setPendingOrders] = useState([]);
  const [acceptOrders, setAcceptOrders] = useState([]);
  const [arrivedOrders, setArrivedOrders] = useState([]);
  const [withdrawnOrders, setWithdrawnOrders] = useState([]);
  const [deliveredOrders, setDeliveredOrders] = useState([]);
  const [canceledOrders, setCanceledOrders] = useState([]);

  function handleChangeOrders(orders, listName) {
    props.setSpinner(true);
    setActualList(listName);
    setOrders(orders)
    setTimeout(() => {
      props.setSpinner(false)
    }, 1000);
  }

  function handleGroupOrder(order, isChecked) {
    if (isChecked) setGroupOrders((prevOrders) => [...prevOrders, order]);
    else setGroupOrders((prevOrders) => prevOrders.filter((o) => o._id !== order._id));
  }

  function renameKeys(obj) {
    if (typeof obj !== 'object' || obj === null) {
      return obj;
    }

    if (Array.isArray(obj)) {
      return obj.map(item => renameKeys(item));
    }

    const newObj = {};
    for (let key in obj) {
      let newKey = key === '_id' ? 'id' : key;
      newObj[newKey] = renameKeys(obj[key]);
    }
    return newObj;
  }

  async function createOrdersGrouping() {
    setLoading(true);
    props.setSpinner(true);
    setTimeout(async () => {
      try {
        const store = renameKeys(selectedStore);
        const response = await orderGroupingService.createOrderGrouping(store, groupOrders);
        props.setSpinner(false);
        props.setTextSpinner('');
        if (response) {
          Swal.fire({
            title: 'Entregas agrupadas com sucesso!',
            icon: 'success',
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          Swal.fire({
            title: 'Ocorreu um erro ao agrupar as entregas!',
            icon: 'error',
            timer: 1500,
            showConfirmButton: false,
          })
        }
        setLoading(false);
        setGroupOrders([]);
        loadOrders();
      } catch (error) {
        Swal.fire({
          title: 'Ocorreu um erro ao agrupar as entregas!',
          text: error,
          icon: 'error',
          timer: 1500,
          showConfirmButton: false,
        })
      }
    }, 2000);
  }

  async function loadOrders() {
    if (loading) {
      return;
    }
    setLoading(true);
    props.setSpinner(true);
    const response = await orderService.getAllOrdersByStore(selectedStore._id);
    switch (actualList) {
      case "PENDING":
        setOrders(response.pendingOrders ? response.pendingOrders : []);
        break;
      case "ACCEPT":
        setOrders(response.acceptOrders ? response.acceptOrders : []);
        break;
      case "ARRIVED":
        setOrders(response.arrivedOrders ? response.arrivedOrders : []);
        break;
      case "WITHDRAWN":
        setOrders(response.withdrawnOrders ? response.withdrawnOrders : []);
        break;
      case "DELIVERED":
        setOrders(response.deliveredOrders ? response.deliveredOrders : []);
        break;
      case "CANCELED":
        setOrders(response.canceledOrders ? response.canceledOrders : []);
        break;
      default:
        break;
    }
    setPendingOrders(response.pendingOrders ? response.pendingOrders : []);
    setAcceptOrders(response.acceptOrders ? response.acceptOrders : []);
    setArrivedOrders(response.arrivedOrders ? response.arrivedOrders : []);
    setWithdrawnOrders(response.withdrawnOrders ? response.withdrawnOrders : []);
    setDeliveredOrders(response.deliveredOrders ? response.deliveredOrders : []);
    setCanceledOrders(response.canceledOrders ? response.canceledOrders : []);
    setTimeout(() => {
      props.setSpinner(false);
    }, 1000);
  }

  function nextPage() {
    setIsChangePage(true);
    setCurrentPage(currentPage + 1);
    setLoading(false);
  }

  function lastPage() {
    if (currentPage !== 1) {
      setIsChangePage(true);
      setCurrentPage(currentPage - 1)
      setLoading(false);
    }
  }

  const refreshOrders = () => {
    setLoading(false);
    loadOrders();
  }

  async function setPendingOrder(order_id, deliveryman_id) {
    const result = await Swal.fire({
      title: 'Deseja solicitar um novo entregador?',
      text: 'O entregador atual será desvinculado e o pedido aguardará um novo entregador!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#17a2b8',
      confirmButtonText: 'Sim, cancelar!',
      cancelButtonText: 'Voltar',
    });

    if (result.isConfirmed) {
      const response = await orderService.setPendingOrder(order_id, deliveryman_id);

      if (response) {
        setLoading(false);
        Swal.fire({
          title: 'Entrega cancelada com sucesso!',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
        });
        return response;
      } else {
        Swal.fire({
          title: 'Ocorreu um erro ao cancelar a entrega!',
          icon: 'error',
          timer: 1500,
          showConfirmButton: false,
        })
      }
    }
  }

  async function ungroupOrders(groupingCode) {
    const result = await Swal.fire({
      title: 'Deseja desafezer o agrupamento?',
      text: 'Essa ação é irreversível!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#17a2b8',
      confirmButtonText: 'Sim, desfazer!',
      cancelButtonText: 'Voltar',
    });

    if(result.isConfirmed) {
      const response = await orderGroupingService.ungroupOrders(groupingCode);
      if (response.ok) {
        Swal.fire({
          title: 'Agrupamento desfeito com sucesso!',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
          didClose: () => {
            setLoading(false);
          }
        });
        return response;
      } else {
        Swal.fire({
          title: 'Ocorreu um erro ao desfazer o agrupamento!',
          icon: 'error',
          timer: 1500,
          showConfirmButton: false,
        })
      }
    }
  }

  async function setPendingGroup(groupingCode, driverId) {
    const result = await Swal.fire({
      title: 'Deseja solicitar um novo entregador?',
      text: 'O entregador atual será desvinculado e o pedido aguardará um novo entregador!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#17a2b8',
      confirmButtonText: 'Sim, solicitar!',
      cancelButtonText: 'Voltar',
    });

    if(result.isConfirmed) {
      const response = await orderGroupingService.setPendingGroup(groupingCode, driverId);
      if (response.ok) {
        Swal.fire({
          title: 'Entrega cancelada com sucesso!',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
          didClose: () => {
            setLoading(false);
          }
        });
        return response;
      } else {
        Swal.fire({
          title: 'Ocorreu um erro ao cancelar a entrega!',
          icon: 'error',
          timer: 1500,
          showConfirmButton: false,
        })
      }
    }
  }

  async function cancelOrder(order_id) {
    const result = await Swal.fire({
      title: 'Deseja cancelar esse pedido?',
      text: 'Essa ação é irreversível!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#17a2b8',
      confirmButtonText: 'Sim, cancelar!',
      cancelButtonText: 'Voltar',
    });

    if (result.isConfirmed) {
      const response = await orderService.cancelOrder(order_id);
      if (response.ok) {
        Swal.fire({
          title: 'Pedido cancelado com sucesso!',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
          didClose: () => {
            setLoading(false);
          }
        });
        return response;
      } else {
        Swal.fire({
          title: 'Ocorreu um erro ao cancelar o pedido!',
          icon: 'error',
          timer: 1500,
          showConfirmButton: false,
        })
      }
    }
  }

  useEffect(() => {
    loadOrders(true);
    document.title = `Acompanhamento | Motum`;
    // eslint-disable-next-line
  }, [loading]);

  useEffect(() => {
    loadOrders(true);
    // eslint-disable-next-line
  }, [selectedStore]);

  const [orderQueue, setOrderQueue] = useState([]);
  const [processing, setProcessing] = useState(false);

  const schedulePushNotification = (data) => {
    setNotificationData(data);
    setShowNotification(true);
    setLoading(false);
    setTimeout(() => {
      setShowNotification(false);
      loadOrders();
      setOrderQueue((prevQueue) => prevQueue.slice(1));
    }, 2000);
    setProcessing(false);
  }

  useEffect(() => {
    const handleUpdateOrder = (data) => {
      setOrderQueue((prevQueue) => [...prevQueue, data]);
    }

    socket.on('DELIVERED_ORDER', handleUpdateOrder);
    socket.on('WITHDRAWN_ORDER', handleUpdateOrder);
    socket.on('ARRIVED_ORDER', handleUpdateOrder);
    socket.on('ACCEPT_ORDER', handleUpdateOrder);
    socket.on('LOADING', loadOrders);

    return () => {
      socket.off('DELIVERED_ORDER', handleUpdateOrder);
      socket.off('WITHDRAWN_ORDER', handleUpdateOrder);
      socket.off('ARRIVED_ORDER', handleUpdateOrder);
      socket.off('ACCEPT_ORDER', handleUpdateOrder);
      socket.off('ACCEPT_ORDER', handleUpdateOrder);
      socket.off('LOADING', loadOrders);
    };
    //eslint-disable-next-line
  }, [socket]);

  useEffect(() => {
    // Process the order queue when it's not empty and not already being processed
    if (orderQueue.length > 0 && !processing && !showNotification) {
      // Set processing to true to prevent simultaneous processing
      setProcessing(true);

      // Get the first order in the queue
      const orderToProcess = orderQueue[0];

      // Execute your function for the order (e.g., schedulePushNotification)
      schedulePushNotification(orderToProcess);
    }
    // eslint-disable-next-line
  }, [orderQueue, processing, showNotification]);

  if (!user) {
    return <Navigate to={'/login'} />;
  }

  const customStyles = {
    option: (provided) => ({
      ...provided,
      cursor: 'pointer',
    }),
  };

  return (
    <React.Fragment>
      <div className="content-container follow-up-container">
        <div className="filter-buttons-container">
          <div className="filter-box" style={{ backgroundColor: '#D4D4D4', borderColor: '#8A8F9B', borderWidth: 2 }} onClick={() => handleChangeOrders(pendingOrders, "PENDING")}>
            <div className="filter-box-count">{pendingOrders.length}</div>
            <div className="filter-box-text">Pendentes</div>
          </div>
          <div className="filter-box" style={{ backgroundColor: '#D56631' }} onClick={() => handleChangeOrders(acceptOrders, "ACCEPT")}>
            <div className="filter-box-count">{acceptOrders.length}</div>
            <div className="filter-box-text">Aceitas</div>
          </div>
          <div className="filter-box" style={{ backgroundColor: '#DEB543' }} onClick={() => handleChangeOrders(arrivedOrders, "ARRIVED")}>
            <div className="filter-box-count">{arrivedOrders.length}</div>
            <div className="filter-box-text">Chegou</div>
          </div>
          <div className="filter-box" style={{ backgroundColor: '#FFF' }} onClick={() => handleChangeOrders(withdrawnOrders, "WITHDRAWN")}>
            <div className="filter-box-count">{withdrawnOrders.length}</div>
            <div className="filter-box-text">Saiu para entrega</div>
          </div>
          <div className="filter-box" style={{ backgroundColor: '#8EDDA6' }} onClick={() => handleChangeOrders(deliveredOrders, "DELIVERED")}>
            <div className="filter-box-count">{deliveredOrders.length}</div>
            <div className="filter-box-text">Realizadas</div>
          </div>
          <div className="filter-box" style={{ backgroundColor: '#C47D7B' }} onClick={() => handleChangeOrders(canceledOrders, "CANCELED")}>
            <div className="filter-box-count">{canceledOrders.length}</div>
            <div className="filter-box-text">Canceladas</div>
          </div>
        </div>
        <div className="content-buttons-header">
          {groupOrders.length > 0 ? (
            <Button
              variant="contained"
              onClick={createOrdersGrouping}
            >
              Criar Agrupamento
            </Button>
          ) : (<div></div>)}
          <div className="group-label" style={{ marginBottom: -30, fontSize: 14 }}>
            <FontAwesomeIcon icon={faLayerGroup} title="Agrupamento" style={{ marginRight: 10, height: 15, color: '#1D5278' }} />
            Entregas agrupadas
          </div>
        </div>
        <OrderList
          orders={orders}
          handleGroupOrder={handleGroupOrder}
          title={"Acompanhamento de Entregas"}
          nextPage={nextPage}
          lastPage={lastPage}
          cancelOrder={cancelOrder}
          setPendingGroup={setPendingGroup}
          ungroupOrders={ungroupOrders}
          hideActionsButtons={false}
          setLoading={setLoading}
          loadOrders={loadOrders}
          refreshOrders={refreshOrders}
          setPendingOrder={setPendingOrder}
          storeOptions={storeOptions}
          placeholder={'Selecione uma Loja'}
          customStyles={customStyles}
          defaultValue={{ value: selectedStore._id, label: selectedStore.companyName }}
        />
        {showNotification ? (<Notification notificationData={notificationData} />) : ("")}
      </div>
    </React.Fragment>
  );
};

export default FollowUp;
